module.exports = __webpack_public_path__ + "img/8dde1845cf2045baefac65b80b3d4343.svg";